// generic dataset presentation page
// receives a json props with all info to build the page
import { data } from 'jquery';
import React from 'react';
import {Link} from 'react-router-dom';
import EpflLoader from '../helper/EpflLoader';
var uniqueID = 0;
const getUniqueID = () => {
    uniqueID = uniqueID + 1;
    return uniqueID;
}
class ChallengeSoftwareInfo extends React.Component {
    constructor(props){
        super(props)
        // grab query
        this.name = new URLSearchParams(this.props.history.location.search).get('software');
        this.modality = new URLSearchParams(this.props.history.location.search).get('modality');
        this.dataPath = "/challenge_results/"+this.name+"/results/"+this.modality +"/";
        this.state = {  frameList:[],
                        orthoList:[],
                        photonList:[],
                        histogramList:[],
                        headers:[],
                        data:[],
                        tableSplit:[0,24,43,56],// split the public.csv table at these index
                        error:""};
                        
        this.imgSize = "1100px";
        this.fetchJSON.bind(this);
        this.isNumeric.bind(this);
        this.navigationDiv.bind(this)
    }
    isNumeric(str) {
        if (typeof str != "string") return false // we only process strings!  
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
               !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
      }
    componentDidMount(){
        // fetch data from server
        this.fetchJSON();
    }
      // fetch the json from server
    fetchJSON(){
        const data = new FormData();
        data.append('SoftwareName',this.name);
        data.append('Modality',this.modality);
        fetch('/api/getSoftwareResults',
        {
            method: 'post',
            headers: {"Accept": "application/text"},
            mode: 'same-origin',
            body: data
        }).then (response => {
            if (response.ok) {
            response.json().then((r) => {
                    // remove entry from the general struct
                    // remove runtime entry
                    r["pngUrlList"].forEach(url => {
                        let filename = url.split("/").pop();
                        if (filename.substring(0,15).includes("Frame") === true)
                            this.state.frameList.push(url)
                        else if (filename.substring(0,15).includes("Ortho") === true)
                            this.state.orthoList.push(url)
                        else if (filename.substring(0,15).includes("photon") === true)
                            this.state.photonList.push(url)
                        else if(filename.substring(0,15).includes("histogram") === true)
                            this.state.histogramList.push(url)
                        

                    })
                    
                    this.setState({headers:r["headers"],
                                    data:r["data"],
                                    error:r["error"]})

                    if (this.state.error.length > 0)
                        console.log(r["error"])
            })
            }
        })
        
    }
    navigationDiv(title){
        return (
            <div style={{display:"flex",justifyContent:"space-between"}}>
                <h2>{title}</h2>
                <div style={{position:"relative",right:"0%"}}>
                    Page navigation links:
                    <a href="#Tables" style={{margin:"10px"}}>Tables</a>,
                    <a href="#Frames" style={{margin:"10px"}}>Frames</a>,
                    <a href="#Ortho" style={{margin:"10px"}}>Ortho</a>,
                    <a href="#Photon" style={{margin:"10px"}}>Photon</a>,
                    <a href="#Histogram" style={{margin:"10px"}}>Histogram</a>
                </div>
            </div>
        )
    }
    render () {

    if (this.state.error.length > 0)
        return (
            <div>
                <h3>The requested software was not part of the challenge.</h3>
                <h4>Return to the <Link to="/Challenge"> leaderboard page</Link>?</h4>
            </div>
        )
    else
        return (
            <div>
                <h1>Challenge results of {this.name} - {this.modality}</h1>
                <p >Back to software general information: <Link to={"/ChallengeSoftwareInfo?name="+this.name}>{this.name}</Link></p>
                <p >Download woble correction: <a href={this.dataPath + "Wobble____"+this.name+".csv"} download>Download</a></p>
                <p >Matlab code used to format the data: <a href={this.dataPath + "convert_"+this.name+".m"} download>Download</a></p>

                {this.state["frameList"].length === 0 ?
                <EpflLoader/>
                :
                <div>
                <div>
                    <a name="Tables"></a>
                    {this.navigationDiv("Statistics on localizations: ")}
                    {this.state["tableSplit"].map((tsplit,splitIndex) => {
                    if (splitIndex > 0)
                    return (
                        <div >
                            <div className="tablesaw-bar tablesaw-mode-stack" style={{margin: "5px"}}/>
                                {/*<table id="tablesaw2" className="table table-sortable tablesaw-stack tablesaw-sortable" data-tablesaw-sortable="true">*/}
                            <table style={{margin:"10px"}} id="tablesaw2" className="table table-sortable tablesaw-stack tablesaw-sortable">
                                <thead>
                                    <tr>
                                        {this.temp = this.state["headers"].filter((h,i) => (i=== 0 | (i >= this.state.tableSplit[splitIndex-1] & i < tsplit) )),
                                        this.temp.map(e => 
                                        <th data-tablesaw-sortable-col key={getUniqueID()}>{e}</th>)
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state["data"].map(e=> <tr>
                                        {this.temp = e.filter((e,i) => (i=== 0 | (i >= this.state.tableSplit[splitIndex-1] & i < tsplit) )),
                                        this.temp.map((val,i) =>
                                        <td key={getUniqueID()}>
                                            {this.isNumeric(val) ? Math.round(parseFloat(val)*100)/100 : val}
                                            </td>
                                        )}
                                    </tr>)}
                                </tbody>
                            </table>
                            <div style={{height:"10px"}}></div> 
                        </div>)
                    })}
                   



                </div>
                <hr></hr>
                <div style={{height:"10px"}}></div>
                    <a name="Frames"/>
                {this.navigationDiv("Individual frames comparison: ")}
                <div style={{display:"flex",flexWrap:"wrap",justifyContent:"center"}}>
                    {this.state["frameList"].map((url,i) => 
                        <div style={{margin:"10px"}}>
                        <img src={url} alt={url} style={{maxWidth:this.imgSize,width:"1100px"}}></img>
                        <div style={{fontSize:"16px",textAlign:"center"}}>{url.split('/').pop().replace(/____/g,' ').replace('_',' ')}</div>
                        </div>
                        )}
                </div>
                <hr></hr>
                <div style={{height:"10px"}}></div>
                    <a name="Ortho"/>  
                {this.navigationDiv("Rendering: ")}
                <div style={{display:"flex",flexWrap:"wrap",justifyContent:"center"}}>
                    {this.state["orthoList"].map((url,i) => 
                        <div style={{margin:"10px"}}>
                        <img src={url} alt={url} style={{maxWidth:this.imgSize,width:"650px"}}></img>
                        <div style={{fontSize:"16px",textAlign:"center"}}>{url.split('/').pop().replace(/____/g,' ').replace('_',' ')}</div>
                        </div>
                        )}
                </div>
                <hr></hr>
                <div style={{height:"10px"}}></div>
                    <a name="Photon" />  
                {this.navigationDiv("Photon correlation statistics: ")}
                <div style={{display:"flex",flexWrap:"wrap",justifyContent:"center"}}>
                    {this.state["photonList"].map((url,i) => 
                        <div style={{margin:"10px"}}>
                        <img src={url} alt={url} style={{maxWidth:this.imgSize,width:"650px"}}></img>
                        <div style={{fontSize:"16px",textAlign:"center"}}>{url.split('/').pop().replace(/____/g,' ').replace('_',' ')}</div>
                        </div>
                        )}
                </div>
                <hr></hr>
                <div style={{height:"10px"}}></div>
                    <a name="Histogram" />  
                {this.navigationDiv("Localization histogram: ")}
                <div style={{display:"flex",flexWrap:"wrap",justifyContent:"center"}}>
                    {this.state["histogramList"].map((url,i) => 
                        <div style={{margin:"10px"}}>
                        <img src={url} alt={url} style={{maxWidth:this.imgSize,width:"650px"}}></img>
                        <div style={{fontSize:"16px",textAlign:"center"}}>{url.split('/').pop().replace(/____/g,' ').replace('_',' ')}</div>
                        </div>
                        )}
                </div>
                </div>
                }
            </div>
            )
    }
}

export default ChallengeSoftwareInfo;